/** @format */

import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import InputAdornment from '@material-ui/core/InputAdornment';
import Error from '@material-ui/icons/ErrorOutline';
import I18n from 'components/Translate/I18n';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class SelectFromRest extends React.Component {
    render() {
        const {
            classes,
            callback,
            label,
            restElements,
            propKey,
            propValue,
            selectedValue,
            addEmpty,
            emptyLabel,
            required,
            stateName,
            stateObjectState,
            displayEmpty,
            disabled,
        } = this.props;

        return (
            <FormControl fullWidth className={classes.selectFormControl} disabled={disabled}>
                <InputLabel htmlFor="simple-select" classes={{ root: classes.SelectFromRestSelectLabelRoot }}>
                    {required ? <I18n trans={label} asterisk={true} /> : <I18n trans={label} />}
                </InputLabel>
                <Select
                    disabled={disabled}
                    displayEmpty={displayEmpty}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        elevation: 0,
                        getContentAnchorEl: null,
                        className: classes.selectMenu,
                    }}
                    classes={{
                        select: classes.select,
                        selectMenu: classes.SelectFromRestSelectMenu,
                    }}
                    value={selectedValue || selectedValue === 0 ? selectedValue : ''}
                    inputProps={{
                        onChange: (event) => callback(event, stateName, required),
                        name: stateName,
                        id: stateName,
                    }}
                >
                    {addEmpty && (
                        <MenuItem disabled classes={{ root: classes.selectMenuItem }} key={'menu_empty_value_' + row[propKey] + row[propValue]}>
                            <I18n trans={emptyLabel} />
                        </MenuItem>
                    )}
                    {restElements &&
                        restElements['hydra:member'].map((row) => {
                            return (
                                <MenuItem
                                    key={'menu_item_value_' + row[propKey] + row[propValue]}
                                    classes={{
                                        root: classes.selectMenuItem,
                                        selected: classes.selectMenuItemSelected,
                                    }}
                                    value={row[propKey]}
                                    name={row[propValue]}
                                >
                                    <I18n trans={row[propValue]} />
                                </MenuItem>
                            );
                        })}
                </Select>
                {stateObjectState && stateObjectState === FormGeneralHelper.ERROR ? (
                    <InputAdornment position="end">
                        <Error className={classes.danger} />
                    </InputAdornment>
                ) : (
                    undefined
                )}
            </FormControl>
        );
    }
}

SelectFromRest.propTypes = {
    classes: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    restElements: PropTypes.object,
    propKey: PropTypes.string.isRequired,
    propValue: PropTypes.string.isRequired,
    addEmpty: PropTypes.bool.isRequired,
    required: PropTypes.bool.isRequired,
    emptyLabel: PropTypes.string,
    stateName: PropTypes.string.isRequired,
    stateObjectState: PropTypes.string,
    displayEmpty: PropTypes.bool,
    disabled: PropTypes.bool,
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withStyles(oplAppStyle)(SelectFromRest);
